const getEnv = (envName: string) => {
    const winEnv = window as any
    if (winEnv.env) {
        return winEnv.env[envName] || process.env[envName]
    }

    return process.env[envName]
}
export const getCurrentLocationTenantID = (): string =>
    getEnv('REACT_APP_LOCATION_TENANT_IDENTIFIER_ID')

export const isProduction = () => {
    return process.env.NODE_ENV === 'production'
}

export default getEnv
